import { render, staticRenderFns } from "./autoras.vue?vue&type=template&id=2a809a40&scoped=true&"
import script from "./autoras.vue?vue&type=script&lang=js&"
export * from "./autoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a809a40",
  null
  
)

export default component.exports